<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    this.checkCurrentLogin();
  },
  updated() {
    var $this = this;
    this.checkCurrentLogin();

    if (this.$route.name != "indexLogin") {
      $this.$http.get("/user").then(function (response) {
        localStorage.setItem("userid", response.data.id);
        localStorage.setItem("username", response.data.razao_social);
        localStorage.setItem("retorno", response.data.retorno);
        localStorage.setItem("seguro", response.data.seguro);
      });
    }
  },
  methods: {
    async checkCurrentLogin() {
      let $this = this;
      if (window.location.href.indexOf("/#/simulacao/") == "-1") {
        // if (window.location.href.indexOf("/#/login") == "-1") {
        //   await $this.$http
        //     .get(
        //       "/login/checkCurrencyUser/" +
        //         localStorage.getItem("userid") +
        //         "/" +
        //         localStorage.getItem("token")
        //     )
        //     .then(function (response) {
        //       if (!response.data) {
        //         localStorage.setItem("token", null);
        //         localStorage.setItem("username", null);
        //         localStorage.setItem("retorno", null);
        //         localStorage.setItem("seguro", null);
        //         localStorage.setItem("feirao", null);
        //         return $this.$router.push({ name: "Login" });
        //       }
        //     });
        // }

        if (
          localStorage.getItem("username") ==
            "MICROSITE AGENCIA DIGITAL LTDA" &&
          localStorage.getItem("token") != null
        ) {
          this.$router.push({ name: "Login" });
        }

        if (
          (!localStorage.getItem("token") && this.$route.name !== "Login") ||
          (localStorage.getItem("token") == null &&
            this.$route.name !== "Login") ||
          (localStorage.getItem("token") == "null" &&
            this.$route.name !== "Login")
        ) {
          this.$router.push({ name: "Login" });
          this.$toastr(
            "warning",
            "Falha ao acessar, você precisar estar logado.",
            "Atenção!"
          );
        }
      }
    },
  },
};
</script>

<style>
.select2-container--default .select2-selection--single {
  background-color: #fff;
  border: 1px solid #aaa;
  border-radius: 10px;
}

.confirm {
  display: none !important;
}

.img-circle {
  border-radius: 0% !important;
}

.nav-link {
  cursor: pointer;
}

.router-link-exact-active {
  background: #78b800 !important;
  color: #fff;
}

#header .dropdown > .dropdown-menu {
  margin-top: -2px;
  margin-left: -70px !important;
}

.tile {
  border-radius: 0px;
  border-top: 3px solid #40978c;
  /*color: #78b800!important;*/
}

.fonts-custom-painel h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0px !important;
  margin-bottom: 5px;
}

.myIcon.icon-success::after,
.myIcon.icon-success.hover-color:hover,
.myIcon.icon-success.icon-color {
  color: #78b800 !important;
}

.text-success {
  color: #78b800 !important;
}

#navigation > li.active > a,
#navigation > li > a:hover {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.form-control {
  border-radius: 10px !important;
  /*height: 40px!important;*/
  /*font-weight: 400!important;*/
  font-size: 14px !important;
  color: #556080 !important;
  /*letter-spacing: .5px!important;*/
  /*padding-top: 7.5px!important;*/
}

.select2-selection--single {
  height: 35px !important;
  border: 1px solid #d2d3d5 !important;
  padding-top: 2px !important;
  /*color: #556080!important;*/
}

.select2-selection__arrow {
  top: 2px !important;
}

#header .dropdown > .dropdown-menu {
  border-radius: 10px !important;
}

.btn {
  border-radius: 0px !important;
  /*height: 40px!important;*/
}

.btn-default {
  color: #333 !important;
  background-color: #fff !important;
  border-color: #ccc !important;
  padding-top: 9px !important;
}

.btn-default:hover,
.btn-default:focus,
.btn-default:active {
  color: #333 !important;
  background-color: #f0f0f0 !important;
  border-color: #ccc !important;
  padding-top: 9px !important;
}

.form-control:focus {
  border: 1px solid #a9abae !important;
}

#navigation {
  margin-left: -32px !important;
}

@media screen and (max-width: 748px) {
  #navigation {
    margin-left: -10px !important;
  }
}

.swal2-popup .swal2-image {
  width: 15% !important;
}

.swal2-popup .swal2-title {
  color: #a9abae !important;
}

.swal2-popup .swal2-styled {
  background: #78b800 !important;
}

.text-warning {
  color: #8a6d3b !important;
}

.swal2-popup .swal2-cancel {
  /*background-color: rgb(170, 170, 170)!important;*/
  background: #fff !important;
  color: #333 !important;
  border: 1px solid #d2d3d5 !important;
}

.swal2-popup .swal2-content {
  color: #616f77 !important;
}

@media only screen and (max-width: 768px) {
  .navbar-default {
    background-color: #309f91 !important;
    border-color: #309f91 !important;
    border-bottom: 3px solid #78b800 !important;
  }

  .navbar-default .navbar-toggle {
    border-color: #78b800 !important;
    background: #78b800 !important;
  }

  .navbar-default .navbar-toggle .icon-bar {
    background-color: #fff !important;
  }

  .navbar-default .navbar-nav > li > a {
    color: rgba(255, 255, 255, 0.7) !important;
  }

  .navbar-default .navbar-nav > .active > a,
  .navbar-default .navbar-nav > .active > a:focus,
  .navbar-default .navbar-nav > .active > a:hover {
    color: #fff ;
    background-color: #78b800 !important;
  }

  .navbar-default .navbar-collapse,
  .navbar-default .navbar-form {
    border-color: #309f91 !important;
  }

  .navbar-default .navbar-nav > .open > a,
  .navbar-default .navbar-nav > .open > a:focus,
  .navbar-default .navbar-nav > .open > a:hover {
    color: #fff;
    background-color: #78b800 !important;
  }

  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus,
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover {
    color: rgba(255, 255, 255, 0.7) !important;
  }
  .navbar-default .dropdown-menu > li > a {
    color: rgba(255, 255, 255, 0.7) !important;
  }

  .navbar-default {
    display: block !important;
  }

  .tab-pane {
    margin-top: -50px !important;
  }

  .modal {
    margin-top: 10px !important;
  }

  #sidebar,
  #header {
    display: none !important;
  }

  .appWrapper.header-fixed.sidebar-xs #content {
    top: 20px !important;
    left: 0px !important;
  }

  #tablePropostas_length select {
    display: none !important;
  }

  .dataTables_wrapper div.dataTables_filter label input,
  .dataTables_wrapper div.dataTables_paginate label input {
    display: inline-block;
    width: 100% !important;
    margin-left: -15px !important;
  }

  .table-responsive {
    border: 1px solid #fff !important;
  }
}

fieldset.scheduler-border {
  border-radius: 10px;
  /*background: #fbf7f733!important;*/
  background: #fbf7f71a !important;
  border: 1px groove #ddd !important;
  padding: 0 1.4em 1.4em 1.4em !important;
  margin: 0 0 1.5em 0 !important;
  -webkit-box-shadow: 0px 0px 0px 0px #000;
  box-shadow: 0px 0px 0px 0px #000;
}

legend.scheduler-border {
  font-size: 1.2em !important;
  font-weight: bold !important;
  text-align: left !important;
  width: auto;
  padding: 0 0px;
  border-bottom: none;
  margin: 0px !important;
  color: #616f77;
  /*color: #78b800;*/
}
.btn-ef.btn-ef-4.btn-ef-4a > i {
  top: 1px !important;
}

.btn-default,
.btn-default:hover,
.btn-default:focus,
.btn-default:active {
  padding-top: 3px !important;
}

.pageheader {
  margin-bottom: 18px !important;
}

.hz-menu #navigation > li > a {
  padding: 12px !important;
}

.btn-continuar:hover,
.btn-continuar:active,
.btn-continuar:focus {
  background-color: #40978c73 !important;
  border-color: #40978c !important;
  color: #fff !important;
}

.btn-success,
.btn-greensea,
.btn-continuar {
  background-color: #40978c !important;
  border-color: #40978c !important;
  color: #fff !important;
}

.toast-container {
  top: 120px !important;
}

.tabs-menu > li.active > a {
  background-color: #78b800 !important;
}

.tabs-menu > li.active::after {
  border-left: 6px solid #78b800 !important;
}

.tile .tile-header h1,
.tile .tile-header h2,
.tile .tile-header h3,
.tile .tile-header h4 {
  font-size: 18px !important;
}

#header .dropdown > .dropdown-menu {
  margin-left: 0px !important;
}

.modal-content {
  -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0) !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0) !important;
}

.modal-content {
  border: 0px !important;
}

.slide-fade-enter-active {
  transition: all 0.6s ease;
}
.slide-fade-leave-active {
  transition: all 0.18s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.navbar-default .navbar-toggle {
  background-color: #309f91 !important;
  border-color: #309f91 !important;
}

.vdp-datepicker__calendar .cell.selected {
  background: #78b800 !important;
  color: #fff !important;
}

.item {
  cursor: pointer;
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: rgb(97, 111, 119);
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd !important;
}

.item-active {
  z-index: 2 !important;
  color: #fff !important;
  cursor: default !important;
  background-color: #78b800 !important;
  border-color: #78b800 !important;
}

.pagination {
  float: right;
}

.table-hide {
  display: none !important;
}

.vuetable-pagination {
  margin-top: -25px !important;
  margin-bottom: 15px !important;
}

.vuetable-pagination-info {
  top: 100px !important;
  margin-top: 50px !important;
  width: 50% !important;
}

.mr-5 {
  margin-right: 0px !important;
}

.sort-icon {
  display: none !important;
}

.checkbox-custom input:checked + i,
.checkbox-custom-alt input:checked + i {
  border-color: #fff;
  background-color: #fff;
}

.checkbox-custom input:checked + i::before,
.checkbox-custom-alt input:checked + i::before {
  background-color: #78b800 !important;
}

.data-parcela[readonly] {
  background-color: #fff !important;
}

.data-parcela[disabled],
fieldset[disabled] .data-parcela {
  background-color: #eee !important;
}

.alert.alert-success {
  color: #5cb85c !important;
  background-color: #eaf6ea !important;
}

.alert.alert-lightred {
  color: #e05d6f !important;
  background-color: #f9dde1 !important;
}
.alert.alert-warning {
  color: #f0ad4e !important;
  background-color: #fef9f3 !important;
}

.alert.alert-cyan {
  color: #22beef !important;
  background-color: #e0f6fd !important;
}

.tr-default {
  border-left: 3px solid rgb(219, 224, 226) !important;
}

.table-striped > tbody > tr:nth-of-type(2n + 1) {
  background-color: #f9f9f9 !important;
}

.router-link-exact-active {
  background: transparent !important;
}

.active {
  background: #2e988c !important;
}

.table-striped .alert-warning,
.table-striped .alert-cyan,
.table-striped .alert-success {
  background: #fff !important;
}

.table-striped > tbody > tr:nth-of-type(2n + 1) {
  background-color: #f9f9f9 !important;
}

.checkbox-custom-alt input[disabled] + i::before {
  background-color: transparent;
  color: #fff;
  font-size: 18px;
  top: -2px;
}

.hz-menu #content {
  top: 125px !important;
}

.table-hide {
  display: table-cell !important;
}

.page-login {
  padding-top: 180px !important;
}

.novaProposta {
  display: none;
  position: fixed !important;
  bottom: 10px !important;
  right: 0px !important;
}

@media only screen and (max-width: 768px) {
  .novaProposta {
    display: block !important;
  }

  .appWrapper.header-fixed.sidebar-xs #content {
    top: 60px !important;
  }
  .table-hide {
    display: none !important;
  }

  .page-login {
    padding-top: 120px !important;
  }

  .toast-container {
    top: 10px !important;
  }

  .page {
    padding: 10px !important;
  }

  .page-login {
    padding-top: 120px !important;
  }

  .vuetable tr {
    cursor: pointer !important;
  }
}

.btn-primary {
  background: #00a694 !important;
  border-color: #00a694 !important;
  color: #fff !important;
}

.icon-success {
  background: #78b800 !important;
}

.modal-header .close {
  margin-top: 0px !important;
}

.close {
  font-size: 24px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue